// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedCenteringCheck_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M32 15H7V35H41V15H43V37H5V13H32V15Z" class="svg-bg"/>
  <path d="M27 24.9989C27 26.6557 25.6569 27.9989 24 27.9989C22.3431 27.9989 21 26.6557 21 24.9989C21 23.342 22.3431 21.9989 24 21.9989C25.6569 21.9989 27 23.342 27 24.9989Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 32.9994C28.4183 32.9994 32 29.4176 32 24.9994C32 20.5811 28.4183 16.9994 24 16.9994C19.5817 16.9994 16 20.5811 16 24.9994C16 29.4176 19.5817 32.9994 24 32.9994ZM24 30.9994C27.3137 30.9994 30 28.3131 30 24.9994C30 21.6856 27.3137 18.9994 24 18.9994C20.6863 18.9994 18 21.6856 18 24.9994C18 28.3131 20.6863 30.9994 24 30.9994Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M38 10.1718L46.2929 1.87891L47.7071 3.29312L38 13.0002L32.2929 7.29312L33.7071 5.87891L38 10.1718Z" fill="#3AD2A3"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M42 25H10V51H54V25H56V53H8V23H42V25Z" class="svg-bg"/>
  <path d="M36.0001 38C36.0001 40.2091 34.2092 42 32.0001 42C29.7909 42 28.0001 40.2091 28.0001 38C28.0001 35.7909 29.7909 34 32.0001 34C34.2092 34 36.0001 35.7909 36.0001 38Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.0001 48C37.5229 48 42.0001 43.5228 42.0001 38C42.0001 32.4772 37.5229 28 32.0001 28C26.4772 28 22.0001 32.4772 22.0001 38C22.0001 43.5228 26.4772 48 32.0001 48ZM32.0001 46C36.4184 46 40.0001 42.4183 40.0001 38C40.0001 33.5817 36.4184 30 32.0001 30C27.5818 30 24.0001 33.5817 24.0001 38C24.0001 42.4183 27.5818 46 32.0001 46Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M48.5006 16.6051L59.0761 5.76758L61.3178 8.06472L48.5006 21.1994L40.9205 13.4316L43.1621 11.1344L48.5006 16.6051Z" fill="#3AD2A3"/>
</svg>
`;
/**
 * IconMedCenteringCheck is a generated icon component.
 */
let IconMedCenteringCheck = IconMedCenteringCheck_1 = class IconMedCenteringCheck extends IconBaseElement {
    render() {
        return html `${IconMedCenteringCheck_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedCenteringCheck.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedCenteringCheck = IconMedCenteringCheck_1 = __decorate([
    customElement('zui-icon-med-centering-check')
], IconMedCenteringCheck);
export { IconMedCenteringCheck };
